import React, { FC } from 'react'

import { Box } from './Box'

import { SectionViewComponentProps } from '../PageSection'
import styled from 'styled-components'

export const Header1: FC<SectionViewComponentProps> = ({
  section,
}: SectionViewComponentProps) => {
  const { content } = section
  if (content) {
    const { heading, text } = content
    return (
      <Container>
        <Heading>{heading}</Heading>
        <Text>{text}</Text>
      </Container>
    )
  }
  return <Box>Header1</Box>
}

const Container = styled.div`
  font-family: 'Poppins_400Regular';
  display: flex;
  flex-direction: column;
  padding: 6px 20px 20px;
  width: 100%;
  box-sizing: border-box;
  border-bottom: 1px solid #000;
`

const Heading = styled.div`
  font-style: normal;
  font-family: 'Poppins_700Bold';
  font-weight: 700;
  font-size: 28px;
  line-height: 42px;
  word-wrap: break-word;
`

const Text = styled.div`
  font-style: normal;
  font-family: 'Poppins_300Light';
  font-weight: 300;
  font-size: 22px;
  line-height: 33px;
  word-wrap: break-word;
`
